import { useQuery } from "@tanstack/react-query";
import { getBrandMagnet } from "apis/brand";
import { getMementoInfo } from "apis/magnets";
import Loading from "components/atoms/Loading";
import { useRouter } from "components/hooks";
import { get } from "utils/request";
import CreateAirDropMemento from "./CreateAirDropMemento";

type Props = {
  isEditForm?: boolean;
};

export const activationKeyURLMap: { [key: string]: ActivationsKeys } = {
  poll: "poll",
  "airdrop-memento": "mem_drop",
  "merch-drop": "merch_drop",
  "claim-code": "claim_code",
  "share-request": "social_share",
};

function AirdropMemento({ isEditForm }: Props) {
  const router = useRouter();

  const { magnetId, brandId, mementoId, mementoType } = router.query;

  const { isLoading, error, data } = useQuery<BrandMagnetDetails>({
    queryKey: ["magnetPublicProfile", brandId, magnetId],
    queryFn: () => get(getBrandMagnet(brandId, magnetId)),
  });
  const {
    isLoading: isMementoLoading,
    // error,
    data: mementoData,
    refetch: revalidateAirdropDetails,
  } = useQuery({
    queryKey: ["Memento", mementoId, magnetId, isEditForm],
    queryFn: () =>
      isEditForm && mementoId ? get(getMementoInfo(magnetId, activationKeyURLMap[mementoType], mementoId)) : null,
  });

  if (isLoading) {
    return <Loading />;
  }

  if (error || !data) {
    return null;
  }

  if (isMementoLoading && mementoId) {
    // TODO: Add Loader Animation here.
    return null;
  }
  return (
    <CreateAirDropMemento
      mementoData={mementoData}
      magnet={data}
      revalidateAirdropDetails={revalidateAirdropDetails}
      activitionKey={activationKeyURLMap[mementoType]}
    />
  );
}
export default AirdropMemento;
